var map = {
	"./abajur-quarto.png": "5a97",
	"./abajur.png": "2d96",
	"./aspirador.png": "a605",
	"./brita.png": "6cc5",
	"./cafe.jpeg": "9105",
	"./caixa-mila.jpg": "d809",
	"./cama-lambrusca.png": "5d17",
	"./capacho.png": "b7b9",
	"./coliseu.jpg": "b925",
	"./espelho.png": "d7ab",
	"./galinha.png": "dc8e",
	"./hotel.jpg": "500a",
	"./jantar-halifax.jpeg": "7c8d",
	"./jogo-americano.jpeg": "f8e8",
	"./jogo-de-talheres.png": "1e61",
	"./jogo-toalhas.png": "aee8",
	"./kit-caipirinha.png": "eea7",
	"./lencol.jpeg": "9518",
	"./mantegueira.png": "7802",
	"./mesa-plantas.png": "48e5",
	"./mesinha-cabeceira.png": "396a",
	"./panela-ferro.png": "4ac2",
	"./panela-pipoca.png": "71d6",
	"./panela-polishop.png": "6f8b",
	"./pdf.png": "6c8a",
	"./pizza.jpeg": "6e57",
	"./pompeia.jpg": "59d4",
	"./potes.png": "4432",
	"./sorvete.png": "e7a5",
	"./tabuas.png": "419f",
	"./tacas.png": "271b",
	"./tapete-banheiro.png": "31e5",
	"./tigelas.png": "f8b0",
	"./tigelonas.png": "dbdc",
	"./trem.png": "c234",
	"./vaso.png": "a66a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5fca";